import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getClientList(filters) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: 'v2/clients/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: filters });
      const { items, total } = processSuccessResponse(res);

      return { items, total };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
